import { RefObject, useEffect } from 'react';
import { customEvents } from '../utils/dom';

export type TEventListener = (event: CustomEvent) => unknown;

export default function useCustomEvent(
  ref: RefObject<HTMLElement | null>,
  event: keyof typeof customEvents,
  callback: TEventListener,
) {
  useEffect(() => {
    function runEvent(e: Event) {
      callback(e as CustomEvent);
    }

    const el = ref.current;

    el?.addEventListener(event, runEvent);

    return () => el?.removeEventListener(event, runEvent);
  }, [callback, event, ref]);
}
